var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileBuilderPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.661,
    height: 46,
    viewBox: "0 0 54.661 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multiple-users-silhouette",
    transform: "translate(0 -6.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55679",
    "data-name": "Path 55679",
    d: "M32.986,14.243a9.932,9.932,0,0,1,4.622,7.379,8.013,8.013,0,1,0-4.622-7.379ZM27.734,30.657a8.016,8.016,0,1,0-8.018-8.016A8.017,8.017,0,0,0,27.734,30.657Zm3.4.546h-6.8A10.277,10.277,0,0,0,14.067,41.469v8.319l.021.13.573.179a46.723,46.723,0,0,0,13.956,2.25c7.544,0,11.917-2.151,12.186-2.288l.535-.271H41.4v-8.32A10.274,10.274,0,0,0,31.134,31.2ZM44.4,22.928h-6.75A9.88,9.88,0,0,1,34.6,29.809,12.2,12.2,0,0,1,43.31,41.481v2.564a27.622,27.622,0,0,0,10.758-2.26l.535-.271h.057V33.192A10.276,10.276,0,0,0,44.4,22.928Zm-30.731-.546a7.963,7.963,0,0,0,4.263-1.237,9.921,9.921,0,0,1,3.729-6.328c.008-.15.023-.3.023-.45a8.016,8.016,0,1,0-8.015,8.015Zm7.2,7.427a9.886,9.886,0,0,1-3.047-6.843c-.25-.018-.5-.038-.753-.038h-6.8A10.276,10.276,0,0,0,0,33.192v8.32l.021.128.573.181a48.126,48.126,0,0,0,11.559,2.173V41.481A12.2,12.2,0,0,1,20.867,29.809Z",
    transform: "translate(0 0)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderPeople);
export default __webpack_public_path__ + "static/media/profile-builder-people.c676ce8fd0ae6c2a7bd77c0b3fd53218.svg";
export { ForwardRef as ReactComponent };